
export default {
    data() {
        return {
            updatedSortedFitters: this.sortedFitters != null ? this.sortedFitters : this.fitters,
            mapIcons: {},
            fittersShown: [],
            filters: {
                postcode: this.postcode,
                distance: this.distance ?? 10,
                sortBy: this.sortBy ?? 'distance',
                fitterTypes: this.fitterTypes ?? ['mobile', 'garage'],
                limit: this.limit ?? 10
            },
            updatedPostcodeDetails: this.postcodeDetails,
            hasSearched: false,
            segments: location.pathname.split('/')
        }
    },
    mounted() {
        if (this.filters.postcode && this.mountedSearch) {
            this.getFitters();
        }

        this.sortMapIcons(this.updatedSortedFitters);
        this.populateFittersShown(this.updatedSortedFitters);

        this.emitter.on('selectFitter', fitter_id => {

            var selectedFitter = document.getElementById(fitter_id);

            selectedFitter.scrollIntoView(true);

            _.forEach(this.updatedSortedFitters, function(fitter, index) {
                if(fitter.id == fitter_id) {
                    fitter['selected'] = true;
                }
                else {
                    fitter['selected'] = false;
                }
            });
        });

        let vm = this;
        this.emitter.on('loadMoreFitters', function() {
            vm.getFitters(true);
        });
    },
    methods: {
        loadGarageFitters() {
            this.filters.fitterTypes.push('garage');
            this.getFitters();
        },
        getFitters(loadMoreFitters) {
            let vm = this;
            var formData = new FormData();
            this.emitter.emit('isLoading', true);

            _.forEach(this.filters, function(value, key) {
                if(key == 'fitterTypes') {
                    _.forEach(value, function(fitterType, key2) {
                        formData.append('fitter_types[]', fitterType);
                    });
                }
                else if(key == 'sortBy') {
                    formData.append('sort_by', value);
                }
                else {
                    formData.append(key, value);
                }
            });

            // Add fitters shown if we are loading more fitters
            if (loadMoreFitters) {
                for (let fitterId of vm.fittersShown) {
                    formData.append('fitters_shown[]', fitterId);
                }
            } else {
                vm.fittersShown = [];
            }

            axios.post('/rechoose-fitters', formData)
            .then(response => {
                var fitters = response.data.sorted_fitters != null ? response.data.sorted_fitters : response.data.fitters;
                const base = response.data.base;

                //to update the map center position with the new lat and long coordinates
                this.emitter.emit('updateCenter', {lat: parseFloat(response.data.postcode_details?.latitude), lng: parseFloat(response.data.postcode_details?.longitude)});
                //this updates postcode_details, to correctly change the home icon position on the map
                vm.updatedPostcodeDetails = response.data.postcode_details;
                
                if(loadMoreFitters == true) {
                    vm.updatedSortedFitters = vm.updatedSortedFitters.concat(fitters);
                }
                else {
                    vm.updatedSortedFitters = fitters;
                }

                this.setFilterQueryParams(this.filters, base);

                this.emitter.emit('isLoading', false);
                this.hasSearched = true;
            })
            .catch(error => {
                console.error("There was an error!", error);

                this.emitter.emit('isLoading', false);
            });
        },
        setFilterQueryParams(filters, base) {
            const searchParams = new window.URLSearchParams(window.location.search);

            for (let key in filters) {
                // Skip adding postcode to URL query params because the postcode is included in the actual route
                if (key === 'postcode') continue;

                const value = filters[key];

                if (Array.isArray(value)) {
                    searchParams.delete(key + '[]');

                    for (let item of value) {
                        searchParams.append(key + '[]', item);
                    }
                } else {
                    searchParams.set(key, value);
                }
            }

            const newRelativePathQuery = base + filters.postcode.toLowerCase() + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        },
        populateFittersShown(val) {
            let vm = this;
            _.forEach(val, function(fitter, key) {
                vm.fittersShown.push(fitter.id);
            });
        },
        loadMoreFitters() {
            this.emitter.emit('loadMoreFitters');
        },
        updateFilters({ key, value }) {
            this.filters[key] = value;

            if (key !== 'distance' && key !== 'postcode') {
                this.getFitters();
            }

            if(key == 'postcode') {
                this.emitter.emit('updatePostcode', value);
            }
        },
        manuallyIncreaseSearchRadius() {
            var queryParams = new URLSearchParams(window.location.search);
            var newDistance = this.filters.distance >= 25 ? 50 : 25;
            queryParams.set("distance", newDistance);
            history.replaceState(null, null, "?"+ queryParams.toString());

            window.location.reload();
        }
    },
    watch: {
        updatedSortedFitters: {
            // deep: true,
            handler(val) {
                this.sortMapIcons(val);
                this.populateFittersShown(val);
            }
        }
    },
    computed: {
        fittedNationallyPage() {
            return this.segments[1] == 'fitted-nationally';
        },
        fittedNationallyLanding() {
            return this.segments[1] == 'fitted-nationally' && this.segments.length <= 2;
        }
    }
}